/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Notes_EmptyInputs */

const en_recipe_notes_empty = /** @type {(inputs: Recipe_Notes_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes yet.`)
};

const de_recipe_notes_empty = /** @type {(inputs: Recipe_Notes_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Notizen.`)
};

/**
* | output |
* | --- |
* | "No notes yet." |
*
* @param {Recipe_Notes_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_notes_empty = /** @type {((inputs?: Recipe_Notes_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Notes_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_notes_empty(inputs)
	return en_recipe_notes_empty(inputs)
});